"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _system = require("@mui/system");
var _Text = _interopRequireDefault(require("../../../../components/Text"));
var _Switch = _interopRequireDefault(require("../../../../components/Switch"));
var _SearchBar = _interopRequireDefault(require("../../../../components/SearchBar"));
var _MemberPremiumBlock = _interopRequireDefault(require("./../components/MemberPremiumBlock"));
var _SectionLine = _interopRequireDefault(require("./../components/SectionLine"));
var _i18n = _interopRequireDefault(require("../../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("@simplybenefits/sb-verbiage/dist/modules/translations/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Block = (0, _system.styled)('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  paddingRight: 10
});
var Row = (0, _system.styled)('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  padding: "5px 30px 0 50px"
});
var styles = {
  currentTransactionsHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 20
  },
  "switch": {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end"
  }
};

/**
 * 
 * @param {*} value 
 * @param {*} users 
 * @param {*} setFilteredUsers 
 */
var _searchInput = function _searchInput(value, users, setFilteredUsers) {
  if (!value) {
    setFilteredUsers(users);
  } else {
    // Perform filtering on the original users array
    var filteredUsers = users.filter(function (user) {
      var userName = "".concat(user.meta.firstname.toLowerCase(), " ").concat(user.meta.lastname.toLowerCase());
      return userName.includes(value.toLowerCase());
    });
    setFilteredUsers(filteredUsers);
  }
};

/**
 * @param users
 * @param accountClasses
 * @param divisions
 * @param blockMemberDetails
 * @param isMemberInvoice
 * @param transaction
 * @returns {JSX.Element|null}
 * @constructor
 */
var CurrentTransactions = function CurrentTransactions(_ref) {
  var users = _ref.users,
    accountClasses = _ref.accountClasses,
    divisions = _ref.divisions,
    blockMemberDetails = _ref.blockMemberDetails,
    isMemberInvoice = _ref.isMemberInvoice,
    transaction = _ref.transaction;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showCurrentTransactions = _useState2[0],
    toggleCurrentTransactions = _useState2[1];
  var _useState3 = (0, _react.useState)(users),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    filteredUsers = _useState4[0],
    setFilteredUsers = _useState4[1];
  if (blockMemberDetails) {
    return null;
  }
  if (isMemberInvoice && transaction) {
    return /*#__PURE__*/_react["default"].createElement(_MemberPremiumBlock["default"], {
      key: 1,
      transaction: transaction,
      isMemberInvoice: isMemberInvoice
    });
  }
  return /*#__PURE__*/_react["default"].createElement(Block, null, /*#__PURE__*/_react["default"].createElement(_SectionLine["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.currentTransactionsHeader
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    largest: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.invoices.currentTransactions)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles["switch"]
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    light: true,
    customStyle: {
      marginBottom: 3,
      marginRight: 10
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.showDetailedCurrentTransactions)), /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
    onChange: toggleCurrentTransactions,
    checked: showCurrentTransactions
  }))), showCurrentTransactions ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SearchBar["default"]
  // searching is done onChange, but we need to pass a function here or we get an error
  , {
    search: function search(e) {
      return null;
    },
    onChange: function onChange(e) {
      return _searchInput(e.target.value, users, setFilteredUsers);
    },
    customStyle: {
      alignSelf: 'flex-start',
      backgroundColor: '#FFF',
      margin: '8px 0 0'
    }
  }), filteredUsers.map(function (user, index) {
    var _accountClasses$user$, _divisions$user$meta$;
    return /*#__PURE__*/_react["default"].createElement(_MemberPremiumBlock["default"], {
      key: index,
      transaction: user,
      classDescription: (_accountClasses$user$ = accountClasses[user.meta.classID]) === null || _accountClasses$user$ === void 0 ? void 0 : _accountClasses$user$.description,
      divisionDescription: (_divisions$user$meta$ = divisions[user.meta.divisionID]) === null || _divisions$user$meta$ === void 0 ? void 0 : _divisions$user$meta$.description
    });
  })) : null);
};
var _default = exports["default"] = CurrentTransactions;